<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import { mapGetters } from 'vuex'
import { Helper } from '@/mixin/helper'
import McBadge from '@/components/McBadge'
import { debounce } from '@/mixin/helper'
import i18n from '../../../i18n'

/**
 * Starter component
 */
export default {
  page: {
    title: 'Setting',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    McBadge,
  },
  mixins: [Helper],
  data() {
    return {
      filter: '',
      allList: [],
      filteredFleet: [],
      filteredTransaction: [],
      filteredCompany: [],
      filteredOthers: [],
      filteredApi: [],
      fleetList: [],
      transactionList: [],
      companyList: [],
      apiList: [],
      otherList: [],
      phaseOneShow: false,
    }
  },

  computed: {
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
      hasAccessAll: 'identity/hasAccessAll',
      isWhitelabel: 'identity/isWhitelabel',
      isParent: 'identity/isParent',
      isNewModule: 'identity/isNewModule',
      getFeatureFlagValue: 'identity/getFeatureFlagValue',
    }),
    title() {
      return this.$t('setting.homePage.pengaturan')
    },
    menuLists() {
      return [
        {
          key: 'product',
          category: 'transaction',
          title: this.$t('setting.homePage.product'),
          description: this.$t('setting.homePage.textProduct'),
          route: 'Setting Product',
          condition: this.hasAccessAll(['tms:create', 'tms:read', 'tms:update', 'tms:delete']),
          icon: 'icon-outline_cube',
        },
        {
          key: 'delivery',
          category: 'transaction',
          title: this.$t('setting.homePage.delivery'),
          description: this.$t('setting.homePage.textDelivery'),
          route: 'Setting Delivery',
          condition: this.hasAccessAll(['tms:create', 'tms:read', 'tms:update', 'tms:delete']),
          icon: 'icon-outline_pending-action',
        },
        {
          key: 'fleet-task',
          category: 'transaction',
          title: this.$t('setting.homePage.fleetTask'),
          description: this.$t('setting.homePage.textFleetTask'),
          route: 'Setting Fleet Task',
          condition: this.hasAccessAll(['tms:create', 'tms:read', 'tms:update', 'tms:delete']),
          icon: 'icon-outline_truck-moving',
        },
        {
          key: 'additional-cost',
          category: 'transaction',
          title: this.$t('setting.homePage.additionalCost'),
          description: this.$t('setting.homePage.textAdditionalCost'),
          route: 'Setting Additional Cost',
          condition:
            this.hasAccessAll(['vms:create', 'vms:read', 'vms:update', 'vms:delete']) &&
            this.$store.state.config.contractVendorAdditionalCostFlag,
          icon: 'icon-outline_folder',
        },
        {
          key: 'user',
          category: 'company',
          title: this.$t('setting.homePage.pengguna'),
          description: this.$t('setting.homePage.textPengguna'),
          route: 'List User Setting',
          condition: this.hasAccessSetUser,
          icon: 'icon-outline_person',
          hasBadge: true,
          badge: {
            condition: this.isNewModule('c1-set-pengguna'),
          },
        },
        {
          key: 'employee',
          category: 'company',
          title: this.$t('setting.homePage.karyawan'),
          description: this.$t('setting.homePage.textKaryawan'),
          route: 'List Employee Setting',
          condition: this.hasAccessAll([
            'employee_recruited_at:read',
            'c2a-default-setkaryawan:read',
          ]),
          icon: 'icon-outline_people',
          hasBadge: true,
          badge: {
            condition: this.isNewModule('c2-set-karyawan'),
          },
        },
        {
          key: 'vehicle',
          category: 'fleet',
          title: this.$t('setting.homePage.kendaraan'),
          description: this.$t('setting.homePage.textKendaraan'),
          route: 'List Fleet Setting',
          condition: this.hasAccessAll(['vehicles:read', 'c3a-default-setkendaraan:read']),
          icon: 'icon-outline_car',
          hasBadge: true,
          badge: {
            condition: this.isNewModule('c3-set-kendaraan'),
          },
        },
        {
          key: 'general',
          category: 'other',
          title: this.$t('setting.homePage.umum'),
          description: this.$t('setting.homePage.textUmum'),
          route: 'List General Setting',
          condition: this.hasAccess([
            'address_categories:read',
            'company_categories:read',
            'c4a-default-setumum:read',
            'c4b-setumum-industrikategori:read',
          ]),
          icon: 'icon-outline_settings',
          hasBadge: true,
          badge: {
            condition: this.isNewModule('c4-set-umum'),
          },
        },
        {
          key: 'company-profile',
          category: 'company',
          title: this.$t('setting.homePage.profilPerusahaan'),
          description: this.$t('setting.homePage.textProfilPerusahaan'),
          route: 'List Company Profile Setting',
          condition: this.hasAccess(['c8a-default-set-profil-perusahaan:read']),
          icon: 'icon-outline_people',
          hasBadge: true,
          badge: {
            condition: this.isNewModule('c8-set-profilperusahaan'),
          },
        },
        {
          key: 'fleet-group',
          category: 'fleet',
          title: this.$t('setting.homePage.grupKendaraan'),
          description: this.$t('setting.homePage.textGrupKendaraan'),
          route: 'List Fleet Group Setting',
          condition: this.hasAccessAll(['vgroups:read', 'c5a-default-setgrupkendaraan:read']),
          icon: 'icon-outline_car-group',
          hasBadge: true,
          badge: {
            condition: this.isNewModule('c5-set-grupkendaraan'),
          },
        },
        {
          key: 'service',
          category: 'fleet',
          title: this.$t('setting.homePage.servis'),
          description: this.$t('setting.homePage.textServis'),
          route: 'List Maintenance Setting',
          condition: this.phaseOneShow,
          icon: 'icon-outline_truck-maintenance',
        },
        {
          key: 'odometer',
          category: 'fleet',
          title: this.$t('setting.homePage.odometer'),
          description: this.$t('setting.homePage.textOdometer'),
          route: 'List Odometer Setting',
          condition: this.hasAccess(['vehicle_odometer:read', 'vehicle_odometer:update']),
          icon: 'icon-outline_odometer',
          hasBadge: true,
          badge: {
            condition: this.isNewModule('c6-set-odometer'),
          },
        },
        {
          key: 'liveview',
          category: 'fleet',
          title: this.$t('setting.homePage.liveView'),
          description: this.$t('setting.homePage.textLiveView'),
          route: 'Setting Live View',
          condition: this.$store.state.config.mode == 'development',
          icon: 'icon-outline_live-view',
        },
        {
          key: 'maintenance',
          category: 'fleet',
          title: this.$t('setting.homePage.pemeliharaanKendaraan'),
          description: this.$t('setting.homePage.textPemeliharaanKendaraan'),
          route: 'List Maintenance Setting',
          condition: this.hasAccess([
            'maintenance:read',
            'maintenance:update',
            'maintenance:create',
            'maintenance:delete',
          ]),
          icon: 'icon-outline_truck-maintenance',
          hasBadge: true,
          badge: {
            condition: this.isNewModule('c10-set-pemeliharaan'),
          },
        },
        {
          key: 'token-api',
          category: 'api-service',
          title: this.$t('setting.homePage.tokenApi'),
          description: this.$t('setting.homePage.textTokenApi'),
          route: 'Setting Token API',
          condition:
            this.getAccessRight() &&
            this.hasAccess('c7a-default-setpengembang:read', 'generate_public_api_key:create'),
          icon: 'icon-outline_code',
          hasBadge: true,
          badge: {
            condition: this.isNewModule('c7-set-pengembang'),
          },
        },
        {
          key: 'white-label',
          category: 'company',
          title: this.$t('setting.list.whitelabel'),
          description: this.$t('setting.list.textWhitelabel'),
          route: 'Management Whitelabel',
          condition:
            this.getAccessRight() &&
            this.hasAccess([
              'c13a-default-logo:read',
              'c13b-default-color:read',
              'c13c-default-banner:read',
              'c13d-default-contact:read',
              'c13e-default-subdomain:read',
            ]) &&
            this.isWhitelabel() &&
            this.isParent(),
          icon: 'icon-outline_color-palette',
        },
        {
          key: 'tracker-and-sensor',
          category: 'fleet',
          title: this.$t('setting.homePage.trackerAndSensor'),
          description: this.$t('setting.homePage.textTrackerAndSensor'),
          route: 'Setting Tracker & Sensor',
          condition: this.hasAccess(['set_idle_parking:read', 'set_fuel:read']),
          icon: 'icon-outline_radio',
        },
        {
          key: 'cost-category',
          category: 'transaction',
          title: this.$t('setting.homePage.costCategory'),
          description: this.$t('setting.homePage.textCostCategory'),
          route: 'Setting Cost Category',
          condition: this.hasAccess([
            'financial-record:create',
            'financial-record:read',
            'financial-record:update',
            'financial-record:delete',
          ]),
          icon: 'icon-outline_rupiah',
        },
        {
          key: 'template',
          category: 'transaction',
          title: this.$t('setting.homePage.template'),
          description: this.$t('setting.homePage.textTemplate'),
          route: 'Sub Setting',
          condition:
            this.hasAccess(['tms:create', 'tms:read', 'tms:update', 'tms:delete']) ||
            this.hasAccess([
              'financial-record:create',
              'financial-record:read',
              'financial-record:update',
              'financial-record:delete',
            ]),
          icon: 'icon-outline_file-text',
        },
        {
          key: 'log',
          category: 'other',
          title: 'User Logs',
          description: this.$t('setting.homePage.logDescription'),
          route: 'User Logs',
          condition: this.hasAccess(['c14a-user-action-log:read']),
          icon: 'icon-fill_menu',
        },
        {
          key: 'integration',
          category: 'api-service',
          title: this.$t('setting.homePage.integration'),
          description: this.$t('setting.homePage.textIntegration'),
          route: 'Integration',
          condition: this.hasAccessAll([
            'tms-integration-accurate:delete',
            'tms-integration-accurate:update',
            'tms-integration-accurate:read',
            'tms-integration-accurate:create',
          ]),
          icon: 'icon-outline_sync',
        },
        {
          key: 'custom-field',
          category: 'company',
          title: this.$t('setting.homePage.customField'),
          description: this.$t('setting.homePage.textCustomField'),
          route: 'Setting Custom Field',
          condition: this.hasAccess([
            'tms:create',
            'tms:read',
            'tms:update',
            'tms:delete',
            'fleet-task-instant:create',
            'fleet-task-instant:read',
            'fleet-task-instant:update',
            'fleet-task-instant:delete',
          ]),
          icon: 'icon-outline_settings',
        },
        {
          key: 'webhook',
          category: 'api-service',
          title: this.$t('setting.homePage.webhook'),
          description: this.$t('setting.homePage.textWebhook'),
          route: 'Setting Webhook',
          condition: this.hasAccess(['webhook_api:read']),
          icon: 'icon-outline_code',
        },
        {
          key: 'management-asset',
          category: 'company',
          title: this.$t('setting.homePage.asset'),
          description: this.$t('setting.homePage.textAsset'),
          route: 'Management Asset',
          condition:
            this.getAccessRight() &&
            this.hasAccess(['c11a-default-gps:read', 'c11b-default-subdomain:read']) &&
            this.isParent(),
          icon: 'icon-outline_sensor-rfid',
        },
        {
          key: 'notification',
          category: 'other',
          title: this.$t('global.object.notification'),
          description: this.$t('setting.list.notification.desc'),
          route: 'Setting Notification List',
          condition: this.hasAccess(['e4b-alert-center-rule-setting:read']),
          icon: 'icon-outline_bell',
        },
        {
          key: 'cutOffAutomation',
          category: 'fleet',
          title: this.$t('setting.homePage.cutOffAutomation'),
          description: this.$t('setting.homePage.textCutOffAutomation'),
          route: 'Setting Engine Off Automation',
          condition:
            this.getAccessRight() &&
            this.hasAccess([
              'c15a-cut-off-engine:read',
              'c15a-cut-off-engine:update',
              'c15a-cut-off-engine:delete',
            ]),
          icon: 'icon-outline_truck-maintenance',
          hasBadge: true,
          badge: {
            condition: this.isNewModule('c15-operational-time'),
          },
        },
        // untuk hak akses
        // {
        //   key: 'access',
        //   category: 'other',
        //   title: this.$t('setting.homePage.hakAkses'),
        //   description: this.$t('setting.homePage.textHakAkses'),
        //   route: 'Setting Access Rights',
        //   icon: 'icon-outline_code',
        //   hasBadge: true,
        // },
        {
          key: 'shift',
          category: 'company',
          title: this.$t('setting.shift.title'),
          description: this.$t('setting.shift.description'),
          route: 'Setting Shift',
          condition: this.hasAccessAll(['users:read', 'c17a-default-shift:read']),
          icon: 'icon-outline_scheduler',
        },
      ]
    },
    hasAccessSetUser() {
      const hasTmsUserGroupScope = this.hasAccessAll([
        'ugroups:read',
        'c1a-default-setpengguna:read',
        'tms-user-group:create',
        'tms-user-group:delete',
        'tms-user-group:read',
        'tms-user-group:update',
      ])

      const hasBasicAccess = this.hasAccessAll(['ugroups:read', 'c1a-default-setpengguna:read'])

      if (hasTmsUserGroupScope) {
        return this.isSuperUser()
      }

      return hasBasicAccess
    },
  },

  watch: {
    '$i18n.locale': function () {
      this.initData()
      this.filter = ''
    },
  },

  mounted() {
    this.initData()
  },

  methods: {
    initData() {
      this.allList = this.menuLists
      this.filteredFleet = this.fleetList = this.menuLists.filter(
        (item) => item.category === 'fleet' && item.condition
      )
      this.filteredTransaction = this.transactionList = this.menuLists.filter(
        (item) => item.category === 'transaction' && item.condition
      )
      this.filteredCompany = this.companyList = this.menuLists.filter(
        (item) => item.category === 'company' && item.condition
      )
      this.filteredApi = this.apiList = this.menuLists.filter(
        (item) => item.category === 'api-service' && item.condition
      )
      this.filteredOthers = this.otherList = this.menuLists.filter(
        (item) => item.category === 'other' && item.condition
      )
    },

    searchData: debounce(function () {
      this.filteredFleet = this.fleetList.filter(
        (item) =>
          item.title.toLowerCase().includes(this.filter.toLowerCase()) ||
          item.description.toLowerCase().includes(this.filter.toLowerCase())
      )
      this.filteredTransaction = this.transactionList.filter(
        (item) =>
          item.title.toLowerCase().includes(this.filter.toLowerCase()) ||
          item.description.toLowerCase().includes(this.filter.toLowerCase())
      )
      this.filteredCompany = this.companyList.filter(
        (item) =>
          item.title.toLowerCase().includes(this.filter.toLowerCase()) ||
          item.description.toLowerCase().includes(this.filter.toLowerCase())
      )
      this.filteredApi = this.apiList.filter(
        (item) =>
          item.title.toLowerCase().includes(this.filter.toLowerCase()) ||
          item.description.toLowerCase().includes(this.filter.toLowerCase())
      )
      this.filteredOthers = this.otherList.filter(
        (item) =>
          item.title.toLowerCase().includes(this.filter.toLowerCase()) ||
          item.description.toLowerCase().includes(this.filter.toLowerCase())
      )
    }, 500),
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" />
    <b-card class="p-2">
      <div class="d-flex justify-content-end">
        <div class="col-3">
          <b-form-input
            v-model="filter"
            type="search"
            :placeholder="$t('global.search') + '...'"
            @input="searchData"
          />
        </div>
      </div>

      <div class="card mc-card mc-card-front">
        <div class="card-body">
          <div v-if="filteredFleet.length > 0" class="my-3">
            <h4 class="mb-3">
              {{ $t('setting.homePage.fleet') }}
            </h4>
            <b-row class="mc-card__list">
              <b-col
                v-for="menu in filteredFleet"
                v-if="menu.condition ?? true"
                :key="menu.key"
                sm="12"
                md="6"
                lg="6"
                xl="4"
                xxl="3"
              >
                <b-button
                  variant="outline-light"
                  class="d-block w-100 mc-card__list-item clearfix"
                  @click="$router.push({ name: menu.route })"
                >
                  <i :class="`mc-fa ${menu.icon}`"> </i>
                  <McBadge
                    v-if="menu.badge?.condition && menu.hasBadge"
                    :text="$t('global.new')"
                    variant="danger"
                    size="medium"
                    type="pill"
                    class="text-uppercase float-end"
                  />
                  <div class="mc-card__list-item-content">
                    <h4>{{ menu.title }}</h4>
                    <p>{{ menu.description }}</p>
                  </div>
                </b-button>
              </b-col>
            </b-row>
          </div>

          <div v-if="filteredTransaction.length > 0" class="my-3">
            <h4 class="mb-3">
              {{ $t('menuitems.transaction.text') }}
            </h4>
            <b-row class="mc-card__list">
              <b-col
                v-for="menu in filteredTransaction"
                v-if="menu.condition ?? true"
                :key="menu.key"
                sm="12"
                md="6"
                lg="6"
                xl="4"
                xxl="3"
              >
                <b-button
                  variant="outline-light"
                  class="d-block w-100 mc-card__list-item clearfix"
                  @click="$router.push({ name: menu.route })"
                >
                  <i :class="`mc-fa ${menu.icon}`"> </i>
                  <McBadge
                    v-if="menu.badge?.condition && menu.hasBadge"
                    :text="$t('global.new')"
                    variant="danger"
                    size="medium"
                    type="pill"
                    class="text-uppercase float-end"
                  />
                  <div class="mc-card__list-item-content">
                    <h4>{{ menu.title }}</h4>
                    <p>{{ menu.description }}</p>
                  </div>
                </b-button>
              </b-col>
            </b-row>
          </div>

          <div v-if="filteredCompany.length > 0" class="my-3">
            <h4 class="mb-3">
              {{ $t('master.list.address.company') }}
            </h4>
            <b-row class="mc-card__list">
              <b-col
                v-for="menu in filteredCompany"
                v-if="menu.condition ?? true"
                :key="menu.key"
                sm="12"
                md="6"
                lg="6"
                xl="4"
                xxl="3"
              >
                <b-button
                  variant="outline-light"
                  class="d-block w-100 mc-card__list-item clearfix"
                  @click="$router.push({ name: menu.route })"
                >
                  <i :class="`mc-fa ${menu.icon}`"> </i>
                  <McBadge
                    v-if="menu.badge?.condition && menu.hasBadge"
                    :text="$t('global.new')"
                    variant="danger"
                    size="medium"
                    type="pill"
                    class="text-uppercase float-end"
                  />
                  <div class="mc-card__list-item-content">
                    <h4>{{ menu.title }}</h4>
                    <p>
                      {{ menu.description }}
                    </p>
                  </div>
                </b-button>
              </b-col>
            </b-row>
          </div>
          <div v-if="filteredApi.length > 0" class="my-3">
            <h4 class="mb-3">
              {{ $t('setting.homePage.apiService') }}
            </h4>
            <b-row class="mc-card__list">
              <b-col
                v-for="menu in filteredApi"
                v-if="menu.condition ?? true"
                :key="menu.key"
                sm="12"
                md="6"
                lg="6"
                xl="4"
                xxl="3"
              >
                <b-button
                  variant="outline-light"
                  class="d-block w-100 mc-card__list-item clearfix"
                  @click="$router.push({ name: menu.route })"
                >
                  <i :class="`mc-fa ${menu.icon}`"> </i>
                  <McBadge
                    v-if="menu.badge?.condition && menu.hasBadge"
                    :text="$t('global.new')"
                    variant="danger"
                    size="medium"
                    type="pill"
                    class="text-uppercase float-end"
                  />
                  <div class="mc-card__list-item-content">
                    <h4>{{ menu.title }}</h4>
                    <p>
                      {{ menu.description }}
                    </p>
                  </div>
                </b-button>
              </b-col>
            </b-row>
          </div>
          <div v-if="filteredOthers.length > 0" class="my-3">
            <h4 class="mb-3">
              {{ $t('global.object.other') }}
            </h4>
            <b-row class="mc-card__list">
              <b-col
                v-for="menu in filteredOthers"
                v-if="menu.condition ?? ''"
                :key="menu.key"
                sm="12"
                md="6"
                lg="6"
                xl="4"
                xxl="3"
              >
                <b-button
                  variant="outline-light"
                  class="d-block w-100 mc-card__list-item clearfix"
                  @click="$router.push({ name: menu.route })"
                >
                  <i :class="`mc-fa ${menu.icon}`"> </i>
                  <McBadge
                    v-if="menu.badge?.condition && menu.hasBadge"
                    :text="$t('global.new')"
                    variant="danger"
                    size="medium"
                    type="pill"
                    class="text-uppercase float-end"
                  />
                  <div class="mc-card__list-item-content">
                    <h4>{{ menu.title }}</h4>
                    <p>
                      {{ menu.description }}
                    </p>
                  </div>
                </b-button>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </b-card>
  </Layout>
</template>

<style lang="scss" scoped>
.mc-card__list-item {
  display: flex;
  min-height: 130px !important;
  height: 90%;

  p {
    text-wrap: wrap !important;
  }
}
</style>
